import { SwipeableDrawer } from "@mui/material";
import SidebarGruposModal, { type SidebarGruposModalProps } from "./SidebarGruposModal";
import ToolbarRestricoesRecurso, { type ToolbarRestricoesRecursoProps } from "./ToolbarRestricoesRecurso";
import ConteudoRestricoes, { type ConteudoRestricoesProps } from "./ConteudoRestricoes";

export type CorpoRestricoesModalProps = {
	readonly isMobile: boolean;
	readonly gruposAbertos: boolean;
	readonly sidebar: Omit<SidebarGruposModalProps, "fluido">;
	readonly toolbar: Omit<ToolbarRestricoesRecursoProps, "onAbrirGrupos">;
	readonly conteudo: ConteudoRestricoesProps;
	readonly onAbrirGrupos: () => void;
	readonly onFecharGrupos: () => void;
	readonly onSelecionarGrupoMobile: (id: number) => void;
};

export default function CorpoRestricoesModal({
	isMobile,
	gruposAbertos,
	sidebar,
	toolbar,
	conteudo,
	onAbrirGrupos,
	onFecharGrupos,
	onSelecionarGrupoMobile,
}: CorpoRestricoesModalProps) {
	return (
		<>
			<div className="flex min-h-0 flex-1 flex-col overflow-hidden md:flex-row">
				{isMobile ? null : <SidebarGruposModal {...sidebar} />}

				<main className="flex min-h-0 min-w-0 flex-1 flex-col">
					<ToolbarRestricoesRecurso {...toolbar} onAbrirGrupos={isMobile ? onAbrirGrupos : undefined} />

					<div className="min-h-0 flex-1 overflow-y-auto px-4 pb-6 pt-4">
						<ConteudoRestricoes {...conteudo} />
					</div>
				</main>
			</div>

			{isMobile ? (
				<SwipeableDrawer
					anchor="left"
					open={gruposAbertos}
					onClose={onFecharGrupos}
					onOpen={onAbrirGrupos}
					disableSwipeToOpen
					sx={{
						zIndex: (theme) => theme.zIndex.modal + 1,
						"& .MuiPaper-root": { width: "min(85vw, 320px)" },
					}}
				>
					<SidebarGruposModal fluido {...sidebar} onSelecionar={onSelecionarGrupoMobile} />
				</SwipeableDrawer>
			) : null}
		</>
	);
}
